import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CustomerRequest, CustomerResponse } from "@builtbybros/al-model";
import { Observable } from 'rxjs';

import { UserGenericComponent } from '../../../user-generic.component';
import { FormsService } from '../../../../shared/forms.service';
import { UserService } from '../../../shared/user.service';
import { UserFormService } from '../../../shared/user-form.service';

@Component({
  selector: 'app-customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.scss', '../../../shared/invalid-form.scss'],
  providers: [UserFormService]
})
export class CustomerFormComponent extends UserGenericComponent {
  customerForm: FormGroup;
  @Input() userRole;

  constructor(
    private fb: FormBuilder,
    private formsService: FormsService,
    private userService: UserService,
  ) {
    super(formsService);
    this.createFormGroup();
  }

  public createFormGroup() {
    this.customerForm = this.fb.group({});
  }

  public getFormGroup(): FormGroup {
    return this.customerForm;
  }

  compareUserRole(role: number): boolean {
    return (role === 2);
  }

  getForm(): FormGroup {
    return this.customerForm;
  }

  submitForm(userInfo: any, id?: number): Observable<CustomerResponse.Customer> {
    let upsert: Observable<CustomerResponse.Customer>;
    if (id) {
      const customer = new CustomerRequest.Update();
      customer.parse(this.customerForm.value);
      customer.parse(userInfo);
      customer.id = id;
      upsert = this.userService.updateCustomer(id, customer);
    } else {
      const customer = new CustomerRequest.Create();
      customer.parse(this.customerForm.value);
      customer.parse(userInfo);
      upsert = this.userService.createCustomer(customer);
    }
    return upsert;
  }
}



// WEBPACK FOOTER //
// ./src/app/user/customer/shared/customer-form/customer-form.component.ts